/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Member_Contact_VisibilityInputs */



/**
* | output |
* | --- |
* | "Your contact info is only visible to you, the IC and your country's NC." |
*
* @param {Profile_Member_Contact_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_member_contact_visibility = /** @type {((inputs?: Profile_Member_Contact_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Member_Contact_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos informations de contact ne sont visibles que par vous, l'IC et le NC de votre pays.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu información de contacto solo es visible para ti, el IC y el NC de tu país.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suas informações de contato só são visíveis para você, o IC e o NC do seu país.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le tue informazioni di contatto sono visibili solo a te, all'IC e all'NC del tuo paese.")
	return /** @type {LocalizedString} */ ("Your contact info is only visible to you, the IC and your country's NC.")
});